import React, { useState,useEffect } from 'react'
import { Flex, Box, Loader } from '@fluentui/react-northstar'
import { Link } from 'react-router-dom';

const Home = (props) => {
  
  const [dashUrl, setdashUrl] = useState("/dashboards/businessPerformance");
  useEffect(() => {
  if (props.user?.PermissionGroupId == "15") {    
   setdashUrl("/dashboards/monitoring/infra/alarms");
  }
  else
  {
  setdashUrl("/dashboards/businessPerformance");
  }
  }, []);
   
    return (
    <>
      <Box className="settings pt-3 pb-1">
        <Flex fill className="error" hAlign="center" vAlign="center">
            <div className="notfound">
              <div className="notfound-section welcome">
                <h1>Welcome!</h1>
                <h2>to Tollring Hub <Link to={dashUrl}>Click Here</Link> to go to Dashboards</h2>
              </div>
            </div>
          </Flex>
      </Box>
    </>
  )
};

export { Home }